import request from '../request'

export function fetchBrandList () {
  return request({
    url: '/data/brand.json',
    baseURL: ''
  })
}

export function fetchDetaiById (params) {
  return request({
    url: '/app/carBrand/getCarBrandDetail',
    method: 'get',
    params
  })
}

export function updateModel (data) {
  return request({
    url: '/app/carBrand/addCarBrandNeeds',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}
